export default __webpack_public_path__ + "static/media/save@2x.e6dc6cb0.png";